import { useMemo } from 'react'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { PdfConfigTemplateAllModulesKey } from './types'
import { TwinIconProp } from '../../../../../../baseComponents/TwinIcon'
import { faBarcode, faImage, faLineHeight, faQrcode, faTable, faText } from '@fortawesome/pro-light-svg-icons'


const usePdfSingleModuleData = () => {
    const { t } = useTwinTranslation()
    const singleModuleData: Record<PdfConfigTemplateAllModulesKey, { icon: TwinIconProp, text: string }> = useMemo(() => {
        return {
            Logo: { icon: faImage, text: t('companyImage', 'Imagen de empresa') },
            Text: { icon: faText, text: t('text', 'Texto') },
            Table: { icon: faTable, text: t('table', 'Tabla') },
            TableRecursive: {icon: faTable, text: t('tableOfElements', 'Tabla de elementos')},
            DrawLine: { icon: faLineHeight, text: t('drawLine', 'Dibujar línea') },
            PrintQR: { icon: faQrcode, text: t('printQr', 'Imprimir QR') },
            PrintBarcode: {icon: faBarcode, text: t('printBarCode', 'Imprimir código de barras')}
        }
    }, [t])
    return { singleModuleData }
}

export default usePdfSingleModuleData